
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSOrderItemsGrid extends Serenity.EntityGrid<POSOrderItemsRow, any> {
        protected getColumnsKey() { return 'Retail.OrderItems'; }
        protected getDialogType() { return POSOrderItemsDialog; }
        protected getIdProperty() { return POSOrderItemsRow.idProperty; }
        protected getInsertPermission() { return POSOrderItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return POSOrderItemsRow.localTextPrefix; }
        protected getService() { return POSOrderItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        
    } 
} 